
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cancel__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.8 25L44.4 7.4c.5-.5.5-1.3 0-1.8s-1.3-.5-1.8 0L25 23.2 7.4 5.6c-.5-.5-1.3-.5-1.8 0s-.5 1.3 0 1.8L23.2 25 5.6 42.6c-.5.5-.5 1.3 0 1.8.2.2.6.4.9.4s.6-.1.9-.4L25 26.8l17.6 17.6c.2.2.6.4.9.4s.6-.1.9-.4c.5-.5.5-1.3 0-1.8L26.8 25z"}})])
          )
        }
      }
    